// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1LMR6","left":"styles_left__a-3Tf"};